import React from 'react';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material';

export const themeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#103c55',
      light: '#0a92de',
      dark: '#103c55',
    },
    secondary: {
      main: '#0a92de',
      light: '#FFE6DE',
      dark: '#05689e',
    },
    background: {
      paper: '#FFFFFF',
      default: '#eceff1',
    },
    text: {
      primary: '#56565d',
    },
    error: {
      main: '#F9473C',
    },
    divider: '#dfdfe4',
  },
  typography: {
    fontFamily: 'Lato',
  },
  overrides: {
    MuiSwitch: {
      root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: 8,
      },
      switchBase: {
        padding: 1,
        '&$checked, &$colorPrimary$checked, &$colorSecondary$checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + $track': {
            opacity: 1,
            border: 'none',
          },
        },
      },
      thumb: {
        width: 24,
        height: 24,
      },
      track: {
        borderRadius: 13,
        border: '1px solid #bdbdbd',
        backgroundColor: '#fafafa',
        opacity: 1,
        transition:
          'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
  },
  shape: {
    borderRadius: 0,
  },
};

let theme = createTheme(themeOptions);
theme = responsiveFontSizes(theme);

const MaterialTheme = ({ children }: { children: React.ReactElement }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default MaterialTheme;
